module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Payment records")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "rounded": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.openAddDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Submit a new Payment"
    }
  }, [_vm._v("add")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.records,
      "data-app": ""
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.name
          }, [_c('td', [_vm._v(_vm._s(_vm.campaignName(item.campaignID)))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatTime")(item.createdAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status == 1 ? 'Approved' : 'Submitted'))])])
        }), 0)]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('form', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Submit a new Payment")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.unpaidCampaigns,
      "item-text": "name",
      "item-value": "id",
      "label": "Campaigns",
      "prepend-icon": "view_list",
      "required": ""
    },
    model: {
      value: (_vm.addForm.campaignID),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "campaignID", $$v)
      },
      expression: "addForm.campaignID"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "hint": "Insert the amount you need to submit (SGD)",
      "required": "",
      "prepend-icon": "attach_money"
    },
    model: {
      value: (_vm.addForm.amount),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "amount", $$v)
      },
      expression: "addForm.amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Attach Receipt/Proof",
      "prepend-icon": "attach_file"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.receipt.click()
      }
    },
    model: {
      value: (this.imageName),
      callback: function($$v) {
        _vm.$set(this, "imageName", $$v)
      },
      expression: "this.imageName"
    }
  }), _vm._v(" "), _c('input', {
    ref: "receipt",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.prepareUpload
    }
  }), _vm._v(" "), (_vm.previewImage) ? _c('img', {
    attrs: {
      "src": _vm.previewImage,
      "width": "100%"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": "",
      "disabled": _vm.loadDialog,
      "loading": _vm.loadDialog
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Submit")])], 1)], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadDialog),
      callback: function($$v) {
        _vm.loadDialog = $$v
      },
      expression: "loadDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Submitting\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6da9db6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Client/Payment.vue
// module id = 2298
// module chunks = 0